var map = {
	"./nav-links.config.1.fr-CA.json": "gdFr",
	"./nav-links.config.1.json": "h9l7",
	"./nav-links.config.10.json": "2Dlp",
	"./nav-links.config.11.json": "8DtA",
	"./nav-links.config.12.json": "3pt8",
	"./nav-links.config.13.fr-BE.json": "+VqP",
	"./nav-links.config.13.json": "DGJg",
	"./nav-links.config.14.json": "VbVM",
	"./nav-links.config.15.json": "XrEo",
	"./nav-links.config.16.de-LU.json": "GxAh",
	"./nav-links.config.16.json": "uF8S",
	"./nav-links.config.17.json": "GfSN",
	"./nav-links.config.18.json": "LoRC",
	"./nav-links.config.19.json": "1E/k",
	"./nav-links.config.2.json": "nT5Q",
	"./nav-links.config.20.json": "UkRS",
	"./nav-links.config.21.json": "1Btd",
	"./nav-links.config.22.json": "GSJc",
	"./nav-links.config.23.json": "KXtW",
	"./nav-links.config.24.json": "G2sB",
	"./nav-links.config.26.json": "3h5q",
	"./nav-links.config.27.json": "0lma",
	"./nav-links.config.28.en-HK.json": "dWwl",
	"./nav-links.config.28.json": "eXVC",
	"./nav-links.config.28.zh-CN.json": "0A+u",
	"./nav-links.config.3.json": "24fl",
	"./nav-links.config.4.json": "LYkF",
	"./nav-links.config.5.json": "aaOy",
	"./nav-links.config.6.json": "gUmZ",
	"./nav-links.config.7.json": "lj5Z",
	"./nav-links.config.8.fr-CA.json": "JDmJ",
	"./nav-links.config.8.json": "e+YS",
	"./nav-links.config.9.json": "VLOx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BB4U";